export default "skymp5-front/4d17f4c25db82da40b220b546c19fedf.gif";